import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable()
export class ExistingSessionGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  /**
   * This guard handles existing session and redirects them to the main page.
   * E.g - If the user is navigating to the login page but has an existing session
   */
  public canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<boolean> {

    return new Promise((resolve) => {
      this.authService
        .hasValidSession()
        .then(() => {
          // Navigate to the user authenticated main page.
          this.router.navigate(['main']);
          resolve(false);
        })
        .catch(() => {
          resolve(true);
        });
    });
  }

}
